import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbtack } from '@fortawesome/free-solid-svg-icons';
import { useApiDocs } from '../../components/apidocs';

/** แถบสรุปท้ายหน้า — Base URL / API Key / อายุออเดอร์ */
const QuickReferenceFooter: React.FC = () => {
  const { apiKey, baseUrl } = useApiDocs();

  const items = [
    { label: 'Base URL', value: baseUrl },
    { label: 'Your API Key', value: apiKey, truncate: true },
    { label: 'Order Expiry', value: '5 minutes' },
    { label: 'Auto-check', value: 'Every 30 seconds' },
  ];

  return (
    <div
      className="mt-6 rounded-2xl overflow-hidden shadow-lg border border-gray-800/50"
      style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)' }}
    >
      <div className="api-docs-shimmer p-5 md:p-6">
        <h3 className="text-base font-bold text-white flex items-center gap-2 mb-4">
          <FontAwesomeIcon icon={faThumbtack} className="text-amber-400 text-sm" /> Quick Reference
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {items.map((item, idx) => (
            <div key={idx}>
              <span className="text-gray-500 dark:text-slate-400 text-[10px] uppercase tracking-wider font-bold">{item.label}</span>
              <code className={`block text-xs bg-white/5 border border-white/10 px-2.5 py-1.5 rounded-lg mt-1.5 text-emerald-400 font-mono ${item.truncate ? 'truncate' : ''}`}>
                {item.value}
              </code>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickReferenceFooter;
